import React, { useState } from 'react';
import css from './SetInterviewBar.module.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import FieldCalendlyMeet from '../FieldCalendlyMeet/FieldCalendlyMeet';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { values } from 'lodash';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import { addOrUpdateWorkerExtraDetails, fetchCurrentUser } from '../../ducks/user.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';

const SetInterviewBarComponent = props => {
  return (
    <FinalForm
      {...props}
      mutators={{ ...arrayMutators }}
      onSubmit={() => {}}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          inProgress,
          invalid,
          intl,
          onOpenTermsOfService,
          tab,
          values,
          history,
          form,
          onManageDisableScrolling,
          userNativeLang,
          errors,
          errorMessage,
          isEmailTakenError,
          currentUserLoaded,
          user,
          isAuthenticated,
          currentSignupUserLoaded,
          currentSignupUser,
          onFetchCurrentUser,
          onAddOrUpdateWorkerExtraDetails,
          socialLoginButtonsMaybe,
          currentUser,
        } = fieldRenderProps;
        const [showCalendlyModal, setShowCalendlyModal] = useState(false);

        const { email } = currentUser ? currentUser?.attributes : '';
        const { firstName, lastName } = currentUser ? currentUser?.attributes?.profile : '';
        const userId = currentUser?.id.uuid;

        //interviewdetails
        const { interviewDetails } = values;
        // console.log(123, values, interviewDetails);

        const interviewDetailsMaybe =
          values?.interviewDetails &&
          values?.interviewDetails.name &&
          values?.interpreterDetails.email
            ? values?.interviewDetails
            : lastName && firstName && email
            ? { name: `${firstName} ${lastName}`, email }
            : { name: '', email: '' };
        // console.log(363, interviewDetailsMaybe);
        const handleSubmit = values => {
          // event.preventDefault();
          // event.stopPropagation();
          // console.log('handleSubmit called');
          // const { values } = props;
          const interviewDetails = {
            eventUri: values.eventUri,
            inviteeUri: values.inviteeUri,
            isConfirmed: values.isConfirmed,
          };
          // console.log(1, interviewDetails);

          const hasInterviewDetails =
            interviewDetails &&
            interviewDetails.eventUri &&
            interviewDetails.inviteeUri &&
            interviewDetails.isConfirmed;

          // console.log(2, interviewDetails, userId, hasInterviewDetails);

          if (hasInterviewDetails) {
            const workerDetails = {
              userId: userId,
              isUpdate: true,
              interviewDetails,
            };
            // console.log(3, workerDetails);
            onAddOrUpdateWorkerExtraDetails(workerDetails);
          }
          setShowCalendlyModal(false);
          // console.log(4, showCalendlyModal);
        };
        const handleCalendlyMeetChange = values => {
          form.change('interviewDetails', values);
          // const {} = { values };
          handleSubmit(values);
        };
        return (
          <div className={css.setinterviewDiv}>
            <div className={css.content}>
              <div className={css.InterviewWrap}>
              <div className={css.intrvwtxt}>
              <FormattedMessage id="SetInterviewBar.SetInterviewMsg" />
              </div>
              <div className={css.intrvwbtn}>
              <button
                // type="submit"
                type="button"
                onClick={() => setShowCalendlyModal(true)}
                // onClick={e => handleSubmit(e, userId)}
              >
                <FormattedMessage id="SetInterviewBar.SetInterviewBtnText" />
              </button>
              </div>
              </div>
            </div>
            <FieldCalendlyMeet
              userNativeLang={userNativeLang}
              id={'interviewDetails'}
              name="interviewDetails"
              initCalendly={showCalendlyModal}
              onChange={handleCalendlyMeetChange}
              inviteeDetails={interviewDetailsMaybe}
            />
          </div>
        );
      }}
    />
  );
};
const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onAddOrUpdateWorkerExtraDetails: params => dispatch(addOrUpdateWorkerExtraDetails(params)),
});
const SetInterviewBar = compose(
  connect(
    null,
    mapDispatchToProps
  ),
  injectIntl
)(SetInterviewBarComponent);
export default SetInterviewBar;
